<template>
  <v-select
    label="Agent Type"
    :outlined="outlined"
    :items="items"
    item-text="name"
    item-value="name"
    v-model="selectedAgentType"
    @change="onChange"
    :clearable="clearable"
  ></v-select>
</template>

<script>
import { removeGQLTypename } from "../../../helpers";
import { ALL_AGENT_TYPES_SEARCH_QUERY } from "../../../constants/graphql";
export default {
  name: "agent-type-list-select",

  props: {
    outlined: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: String,
      default: () => "",
    },
    clearable: {
      type: Boolean,
      default: () => true,
    },
  },

  data() {
    return {
      selectedAgentType: this.value ? this.value : null,
    };
  },
  computed: {
    items() {
      return this.agentTypes && this.agentTypes.edges
        ? this.agentTypes.edges.map(removeGQLTypename)
        : [];
    },
  },

  watch: {
    value(newVal) {
      if (newVal) {
        this.selectedAgentType = newVal;
      }
    },
  },

  methods: {
    onChange() {
      this.$emit("input", this.selectedAgentType ? this.selectedAgentType : '');
    },
  },

  apollo: {
    agentTypes: {
      query: ALL_AGENT_TYPES_SEARCH_QUERY,
      variables() {
        return {
          filter: {
            not_in_use_eq: false,
          },
        };
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/AgentTypeListSelect.vue